import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  quote: string;
  author: string;
  title: string;
  company: string;
  rating: number;
}

const TestimonialsSection = () => {
  const testimonials: Testimonial[] = [
    {
      quote: "The AI Change Leaders network has been transformational for my consulting practice. Access to enterprise clients and proven methodologies has allowed me to deliver results I couldn't achieve independently.",
      author: 'Marcus Williams',
      title: 'Principal Consultant',
      company: 'Strategic Insights Ltd',
      rating: 5
    },
    {
      quote: "Joining this network was the best decision for my boutique firm. The collaborative model and shared expertise have elevated our capabilities and opened doors to Fortune 500 engagements.",
      author: 'Lisa Chen',
      title: 'Managing Director',
      company: 'Transform Partners',
      rating: 5
    },
    {
      quote: "The certification program and ongoing methodology support give me confidence tackling complex AI transformations. The partner community is invaluable for knowledge sharing and collaboration.",
      author: 'Robert Taylor',
      title: 'Senior Transformation Consultant',
      company: 'Digital Evolution Group',
      rating: 5
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold font-headline text-primary mb-6">
            What Partners Say
          </h2>
          <p className="text-lg text-muted-foreground font-body">
            Hear from consultants and firms who have transformed their practices through our network.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-8 shadow-card hover:shadow-modal transition-all duration-300 border border-border"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, idx) => (
                  <Icon key={idx} name="StarIcon" size={20} variant="solid" className="text-accent" />
                ))}
              </div>
              
              <p className="text-foreground font-body leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </p>
              
              <div className="pt-4 border-t border-border">
                <div className="font-bold font-headline text-primary mb-1">
                  {testimonial.author}
                </div>
                <div className="text-sm text-muted-foreground font-body mb-1">
                  {testimonial.title}
                </div>
                <div className="text-sm text-secondary font-semibold font-body">
                  {testimonial.company}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;